import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-secondary-500 uppercase tracking-wider mb-2">TOPIC INDEX</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">主题索引</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            吃瓜网站大全主题分类索引，快速找到你感兴趣的吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-secondary-600 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-semibold text-foreground-900 text-sm group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}